/**
 * CatalogController — /api/v1/catalog
 * Mirrors: src/Aidepo.Api/Controllers/CatalogController.cs
 *
 * Read-only reference data: 8 typical equipment types and their default
 * maintenance-schedule rules. Used by the equipment-add screens to pre-fill
 * a proposed schedule.
 */
import { apiGet } from '../client.js';

/** One rule of a default maintenance schedule. */
export interface CatalogRule {
  readonly title: string;
  readonly periodMonths: number;
  readonly isSafetyCritical: boolean;
}

/** A catalog equipment type with its default schedule. */
export interface CatalogEntry {
  readonly type: string;
  readonly displayName: string;
  readonly category: string;
  readonly rules: readonly CatalogRule[];
}

export interface CatalogResponse {
  readonly equipment: readonly CatalogEntry[];
}

/** GET /api/v1/catalog/equipment — 8 equipment types with default schedules. */
export function getEquipmentCatalog(): Promise<CatalogResponse> {
  return apiGet<CatalogResponse>('/api/v1/catalog/equipment');
}
